var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"provider-validation"},[(_vm.service_id && _vm.provider_id)?_c('iframe',{staticClass:"min-h-68 iframe",attrs:{"src":`${_vm.report_url}/${_vm.service_id}/${_vm.provider_id}`,"frameborder":"0","width":"100%","height":"100%"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }